import { useCallback } from "react";

import { useSnackbar } from "notistack";

import { trpc } from "@/common/helpers/trpc";
import { useTranslate } from "@/common/hooks/useTranslate";
import {
  ChargeDateChange,
  getEditChargeDateErrorMessage,
} from "@/components/EditChargeDateDialog/helpers/useEditChargeDate";

export const useEditDonorChargeDate = ({ refetch }: { refetch: () => void }) => {
  const { t } = useTranslate();
  const { enqueueSnackbar } = useSnackbar();

  const { mutateAsync: execEditDonorCommandSubscriptionChargeDate, isPending: editChargeDateIsLoading } =
    trpc.editDonorCommandSubscriptionChargeDate.useMutation();

  const editChargeDate = useCallback(
    async (commandId: string, newChargeDate: ChargeDateChange) => {
      const { data, error } = await execEditDonorCommandSubscriptionChargeDate({ id: commandId, ...newChargeDate });
      if (error || !data) {
        enqueueSnackbar(getEditChargeDateErrorMessage(t, error?.code), { vibe: "danger" });
        return false;
      }
      refetch();
      enqueueSnackbar(t("dashboard", "editChargeDateDialog.success"), {
        vibe: "positive",
      });
      return true;
    },
    [execEditDonorCommandSubscriptionChargeDate, enqueueSnackbar, t, refetch]
  );

  return { editChargeDate, editChargeDateIsLoading };
};
